import {UiBaseIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "70",
  height: "70",
  viewBox: "0 0 70 70"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("rect", {
        width: "70",
        height: "70",
        fill: "#FEEBE2",
        rx: "35"
      }),
      _createElementVNode("path", {
        fill: "#E25E20",
        "fill-rule": "nonzero",
        d: "M34.116 40.542a694.79 694.79 0 0 1-.24-18.724h3.117c0 5.918-.067 12.159-.2 18.724h-2.677zm-.48 7.64v-4.019h3.637v4.019h-3.637z"
      })
    ], -1)
  ])))
}
export default { render() { return h(UiBaseIcon, {icon: {render}, name: "icon-warning"}) } }